import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import GoldPriceDisplay from './components/GoldPriceDisplay';
import BlogSection from './components/BlogSection';
import BlogPost from './pages/BlogPost';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Disclaimer from './pages/Disclaimer';
import GoldCalculator from './pages/GoldCalculator';
import GoldPrices from './pages/GoldPrices';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={
              <>
                <GoldPriceDisplay />
                <BlogSection />
              </>
            } />
            <Route path="/gold-calculator" element={<GoldCalculator />} />
            <Route path="/gold-prices" element={<GoldPrices />} />
            <Route path="/blog/:id" element={<BlogPost />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App; 